import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=46fdc76a&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=46fdc76a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fdc76a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46fdc76a')) {
      api.createRecord('46fdc76a', component.options)
    } else {
      api.reload('46fdc76a', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=46fdc76a&scoped=true&", function () {
      api.rerender('46fdc76a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Z9AB1gbL4Rz7/JS/comp/DocBox.vue"
export default component.exports